import React from 'react';
import { Button } from '@mui/material';
import { SnackbarProvider, closeSnackbar } from 'notistack';

export const SnackbarProviderWrapper = ({ children }: { children: React.ReactNode }) => {
    const notistackRotRef = React.useRef<HTMLElement>();

    React.useEffect(() => {
        if (!notistackRotRef.current) {
            const notistackRoot = document.getElementById('notification-root');
            if (notistackRoot) {
                notistackRotRef.current = notistackRoot;
            }
        }
    }, []);

    const handleDismissSnackbar = React.useCallback(
        (snackbarId: string | number) => () => {
            closeSnackbar(snackbarId);
        },
        []
    );

    const dismissAction = React.useCallback(
        (snackbarId: string | number) => (
            <Button color="inherit" onClick={handleDismissSnackbar(snackbarId)}>
                Dismiss
            </Button>
        ),
        [handleDismissSnackbar]
    );

    return (
        <SnackbarProvider
            anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
            autoHideDuration={3000}
            action={dismissAction}
            domRoot={notistackRotRef.current}
        >
            {children}
        </SnackbarProvider>
    );
};
